import { defineComponent as _defineComponent } from 'vue'
import Reservation from '@/model/Reservation';
import ReservationChips from '@/components/views/guests/ReservationChips.vue';
import { createPopper } from '@popperjs/core';
import {
  ref, PropType, computed, Ref, nextTick,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeTableTooltip',
  props: {
  reservation: { type: Object as PropType<Reservation>, required: true },
},
  setup(__props) {

const props = __props;


const mouseIsOver = ref(false);
const hideTimeout = ref(undefined as undefined | number);

const hasExtraInfo = computed(() => (props.reservation.notes !== null && props.reservation.notes.length > 0)
        || props.reservation.paymentInfo !== undefined
        || props.reservation.service !== null
        || props.reservation.fixedEnding
        || props.reservation.label !== null
        || props.reservation.attachments.length > 0);

const tabItems = computed(() => props.reservation.tabItems.map((t) => t.no).join(', '));

const mouseInsidePopover = () => {
  window.clearTimeout(hideTimeout.value);
};

const hidePopover = () => { mouseIsOver.value = false; };
const scheduleHidePopover = () => {
  window.clearTimeout(hideTimeout.value);
  hideTimeout.value = window.setTimeout(() => { hidePopover(); }, 100);
};

const tooltip = ref(null) as Ref<null | HTMLElement>;
const createPopover = (el: any) => {
  if (mouseIsOver.value) { return; }
  mouseIsOver.value = true;
  const boundary = document.getElementById('tt-scrollable-container');

  nextTick(() => {
    const tt = (tooltip.value as HTMLElement);
    // console.log(`p: ${el} t: ${tooltip} b: ${boundary}`);

    createPopper(el, tt, {
      placement: 'auto',
      strategy: 'fixed',
      modifiers: [
        {
          name: 'preventOverflow',
          options: {
            boundary,
            padding: 8,
            altAxis: true,
          },
        },
      ],
    });
  });
};


return { __sfc: true,props, mouseIsOver, hideTimeout, hasExtraInfo, tabItems, mouseInsidePopover, hidePopover, scheduleHidePopover, tooltip, createPopover, ReservationChips }
}

})